import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Page, Wrapper, Paper, Button, Toolbar, AlertConfirm, Table, Row, Cell, Tag, LinkCategory } from './../../../components/ui';
import { CategoryService } from './../../../services';
import { isUndefined, isStatus, isStatusColor, isLevel, hasPermission, findPermissionProps } from './../../../utilities/utils';

import API from './../../../config/api';
import TEXT from './../../../config/text';

class Page__CategoryList extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        permission: null,
        name: "...",
        loading: false,
        page: 0,
        total: 0,
        id: null,
        entity: null,
        entities: [],
        remove: false,
        thead: [
          { id: 'name', name: this.props.t('field.name') },
          { id: 'position', name: this.props.t('field.position') },
          { id: 'enabled', name: this.props.t('field.status') },
          { id: 'level', name: this.props.t('field.level') },
          { id: 'actions', name: this.props.t('field.actions'), align: 'right' }
        ]
      };
    };

    /**
    * @Event
    * @Description: Is invoked immediately after a component is mounted.
    */
    componentDidMount(){
      this._Init();
    };

    /**
    * @Event
    * @Description: Is invoked immediately after a component will recive props.
    */
    componentDidUpdate(prev_props){

      if(this.props.match.params.page !== prev_props.match.params.page){
        this._All(this.props.match.params.page || 0);
      }

      if(this.props.match.params.id !== prev_props.match.params.id){
        this._All(this.props.match.params.page || 0, this.props.match.params.id);
      }

    };

    /*
    ** @Event
    ** @Description: Init
    */

    _Init = () => {

      this.setState({ permission: findPermissionProps(this.props.session, API.permissions.categories, this.props.t('page.categories.name')) });

      const page = this.props.match.params.page || 0;
      const id   = this.props.match.params.id;

      if(!isUndefined(page)){
        if(!isNaN(page) && page >= 0){
          if(id){
            this._All(page, id);
          }else{
            this._All(page);
          }
        }else{
          this.props.history.push('/categories');
        }
      }else{
        this._All(this.state.page);
      }

    };

    /*
    ** @Service
    ** @Description: All categories
    */

    _All = (page, id) => {

      // @State
      // @Description: Refresh after each service
      this.setState({ loading: false, entities: [] });

      let params = {};

      // @If
      // @Description: If id exist set param parent id
      if (id) params.parent = id;

      // @Service
      CategoryService.list(page, params).then((response) => {

        if(response.categories.length > 0){

          this.setState({
            loading: true,
            page: !isUndefined(page) ? parseInt(page,10) : 0,
            entities: response.categories,
            total: response.total
          });

        }else{

          // @Redirect
          this.props.history.push(`/categories/page/0`);

          // @State
          this.setState({ loading: true });

        }

      }).catch((error) => {

        // @Dispatch alert error
        this.props.alertShow({
          open: true,
          severity: 'error',
          message: TEXT.message.error
        });

      });

    };

    /*
    ** @Service
    ** @Description: Remove
    */

    _Remove = (id) => {

      CategoryService.remove(id).then((response) => {

        // @State
        this.setState({ remove: false });

        // @Service find all by page
        this._Init();

        // @Dispatch alert success
        this.props.alertShow({
          open: true,
          severity: 'success',
          message: `La categoría fue eliminada.`
        });
      }).catch((error) => {

        // @Dispatch alert error
        this.props.alertShow({
          open: true,
          severity: 'error',
          message: `El cliente no pudo ser eliminado.`
        });
      });

    };

    /*
    ** @Event
    ** @Description: Remove
    */

    handleRemove = (id) => {
      this.setState({ id: id, remove: true });
    }

    /*
    ** @Click
    ** @Description: Remove confirm
    */

    handleConfirmRemoveConfirm = () => {
      this._Remove(this.state.id);
    };

    /*
    ** @Click
    ** @Description: Remove cancel
    */

    handleConfirmRemoveCancel = () => {
      this.setState({ remove: false });
    };

    /*
    ** @Handle
    ** @Description: Change page
    */

    handleChangePage = (event, page) => {
      this.setState({ page: page, loading: false });
      this.props.history.push(`/categories/page/${ page }`);
    };

    render(){

      const { session } = this.props;
      const { permission, name, loading, entities, thead, total, page, remove } = this.state;

      return(
        <Page>

          <Wrapper>

            <Toolbar
              title={permission ? permission.name : name}
              dividerMobile
            >
              <Button
                component={ NavLink }
                to="/categories/create"
                icon="add"
                size="medium"
              >
                {this.props.t('button.create')}
              </Button>
            </Toolbar>

            <Paper disablePadding>

                <AlertConfirm
                   status={ remove }
                   message="¿Confirma la eliminación de la categoría?"
                   cancel={ () => { this.handleConfirmRemoveCancel() } }
                   confirm={ () => { this.handleConfirmRemoveConfirm() } }
                />

                <Table
                  thead={ thead }
                  loading={ loading }
                  total={ total }
                  page={ page }
                  onChangePage={ this.handleChangePage }
                >

                  { entities.length > 0 && (

                    entities.map(entity => {
                      return (
                        <Row key={ entity._id }>
                          <Cell>
                            <LinkCategory category={ entity }/>
                          </Cell>
                          <Cell>{ entity.position }</Cell>
                          <Cell>
                            <Tag
                              text={ isStatus(entity.enabled) }
                              color={ isStatusColor(entity.enabled) }
                            />
                          </Cell>
                          <Cell>
                            <Tag
                              text={ isLevel(entity.parent) }
                              color="secondary"
                            />
                          </Cell>
                          <Cell align="right" nowrap>

                            { hasPermission(session.user.permissions, API.permissions.categories_management) && (
                              <React.Fragment>
                                <Button
                                  color="primary"
                                  icon="edit"
                                  component={ NavLink }
                                  title={this.props.t('button.edit')}
                                  to={ `/categories/edit/${ entity._id }` }
                                />
                                <Button
                                  color="danger"
                                  icon="cancel"
                                  title={this.props.t('button.delete')}
                                  onClick={ () => this.handleRemove(entity._id)  }
                                />
                              </React.Fragment>
                            )}

                          </Cell>
                        </Row>
                      )
                    })

                  )}

                  { (loading && entities.length === 0) && (
                    <Row>
                      <Cell colSpan={ thead.length } align="center">
                        { TEXT.message.without_results }
                      </Cell>
                    </Row>
                  )}

                </Table>


            </Paper>

          </Wrapper>

        </Page>
      )
    }

};

const mapStateToProps = (state) => {
  return {
    session: state.userState
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__CategoryList));
